import { mapState } from 'vuex'

export default {
  components: {
    HeaderBlock: () => import('~/components/commom/header/index'),
    ButtonBlock: () => import('~/components/commom/button-block/index'),
    lifeInsuranceForm: () =>
      import('~/components/layouts/life-insurance-form/index')
  },
  async fetch({ store }) {
    if (store.state.team.members.length === 0) {
      await store.dispatch('team/getTeam')
    }
  },
  data() {
    return {
      activeStep: 0,
      lifeData: {},
      isSending: false
    }
  },
  computed: {
    ...mapState(['auth']),
    teamMember() {
      return this.$store.state.team.members[0]
    },
    simulationData() {
      return {
        company_id: 1,
        insured_name: this.lifeData.firstName,
        insured_lastname: this.lifeData.lastName,
        insured_email: this.lifeData.email,
        insured_phone: this.lifeData.phone,
        insured_dob: this.lifeData.applicantDateOfBirth,
        insured_dob2: this.lifeData.secondApplicantDateOfBirth,
        amount: this.lifeData.owedValue,
        tan: this.lifeData.tan,
        applicants: parseFloat(this.lifeData.numberOfApplicants),
        term: this.lifeData.numberOfLownYears,
        premium: this.lifeData.currentPremium,
        indexation: this.lifeData.indexation,
        spread: this.lifeData.spread,
        bank: this.lifeData.bank,
        profession: this.lifeData.profession
      }
    }
  },

  methods: {
    isStepActive(index) {
      return index === this.activeStep
    },

    goToNextStep() {
      this.$gtm.pushEvent({
        event:
          this.activeStep === 0
            ? 'life_simulation_start'
            : 'life_simulation_completed'
      })

      this.activeStep++
      window.scrollTo(0, 0)
    },

    submitForm() {
      if (this.isSending) {
        return
      }

      this.isSending = true

      this.sendToServer()
        .then((response) => {
          this.isSending = false

          this.$gtm.pushEvent({
            event: 'life_simulation'
          })

          return this.handleSucessSubmission(response.data)
        })
        .catch((_error) => {
          this.isSending = false
        })
    },

    sendToServer() {
      return this.$axios.post(
        '/lifeinsurance/createquote',
        this.simulationData,
        {
          headers: {
            'Content-type': 'application/json; charset=utf-8'
          },
          withCredentials: true
        }
      )
    },

    handleSucessSubmission(response) {
      this.saveSimulationOnStorage(response.uuid)
      this.saveSimulationData(this.simulationData)
      this.$router.push(
        this.localePath({
          name: 'simulacao-seguro-vida-resultados-id',
          params: {
            id: response.uuid
          }
        })
      )
    },
    saveSimulationData(simulationData) {
      return this.$store.commit('localStorage/SAVE_SIMULATION_DATA', {
        simulationData
      })
    },
    saveSimulationOnStorage(id) {
      if (this.auth.isLoggedIn) {
        return
      }

      return this.$store.commit('localStorage/ADD_ANONYMOUS_LIFE_SIMULATION', {
        id
      })
    }
  }
}
